import './DashboardV3.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores";
import {CurrencyComponent} from "../../currency-component/CurrencyComponent.tsx";
import {DashboardSection} from "./DashboardSection.tsx";
import type {DashboardCard} from "../DashboardCardConfigs.tsx";
import ChartInfoIcon from '../../icons/svg/DashboardIcon.svg?react';
import DatabaseIcon from '../../icons/svg/DatabaseIcon.svg?react';
import {KpiBoxedValues} from "../../kpi-boxed-values/KpiBoxedValues.tsx";
import {DashboardChatSection} from "./dashboard-chat-section/DashboardChatSection.tsx";

/**
 * Dashboard that uses only merge-1 links, without any databags in the url
 * Used by: franke
 */
export const DashboardV3: React.FC = observer(() => {
    const {p, bagStore} = useStores();

    const isSample = bagStore.isSample;
    const commonKpi = bagStore.kpi.common;
    const dashboardKpisValues = React.useMemo<{ title: string, subtitle: React.ReactNode }[]>(() => [
        {
            title: isSample ? 'Suppliers for validation' : 'Suppliers',
            subtitle: commonKpi ? String(commonKpi.n_suppliers) : ''
        },
        {
            title: 'Categories',
            subtitle: commonKpi ? String(commonKpi.n_categories) : ''
        },
        {
            title: isSample ? 'Spend for validation' : 'Spend',
            subtitle: commonKpi ? <CurrencyComponent v={commonKpi.total_spend} nDigits={3}/> : ''
        },
    ], [isSample, commonKpi]);

    const cards1 = ([
        'taxonomy-suggester',
        'taxonomy-builder',
        'categorization-review',
        'supplier-normalization',
        'contract-insights',
        'golden-record',
    ] satisfies DashboardCard[]).filter(card => p.showCard(card));
    const cards2 = ([
        'adv-dashboard',
        'koi-key-data-facts',
        'koi-spend-concentration',
        'koi-ppv',
    ] satisfies DashboardCard[]).filter(card => p.showCard(card));

    return <div className="dashboard-v3">
        {p.p.enableProcChat && <DashboardChatSection/>}

        <KpiBoxedValues values={dashboardKpisValues}/>
        <DashboardSection
            title="Data Foundation"
            icon={<DatabaseIcon className="header-icon"/>}
            cards={cards1}
        />
        <DashboardSection
            title="Actionable Insights"
            icon={<ChartInfoIcon className="header-icon"/>}
            cards={cards2}
        />
        {/*{p.p.enableProcChat && <ChatOverlayComponent/>}*/}
    </div>
});
